import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "../styling/login.css";
import { useHistory } from "react-router-dom";
//the NavBar in Login and Signup form Component
import NavBar from "../components/NavBar";
import AuthService from "../services/auth";
import larlogo from "../assets/logo-beta.png";
import Carousel from "react-bootstrap/Carousel";
import img1 from "../assets/signup graphics/financial tracking.png";
import img2 from "../assets/signup graphics/expensetracker.png";
import img3 from "../assets/signup graphics/pricingdiscovery.png";
import img4 from "../assets/signup graphics/analyticsandoptimization.png";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import "bootstrap/dist/css/bootstrap.min.css";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { GoogleLogin } from "react-google-login";
import useMediaQuery from '@mui/material/useMediaQuery';
import { ReactComponent as WarningIcon } from "../assets/warning_icon.svg";
import ReactGA from "react-ga";
import { MobileView } from "react-device-detect";
import Col from "react-bootstrap/Col";
import * as rdd from "react-device-detect";
import { toast } from "react-toastify";
interface LoginProps {}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: "#dff5e4",
      textAlign: "center",
    },
    drawer: {
      textAlign: "center",
    },
    drawerPaper: {
      width: "16.67%",
      textAlign: "center",
    },
    logo: {
      width: 101,
      height: 43,
      flexGrow: 0,
      padding: "0 0 1.4px",
    },
    logoBox: {
      display: "flex",
      // justifyContent: "center",
      margin: "10px",
      marginTop: "30px",
      marginRight: "auto",
      marginLeft: "10%",
    },
    mobileLogoBox: {
      display: "flex",
      justifyContent: "center",
    },
    logoIn: {
      fontSize: 24,
      fontWeight: "bold",
      textAlign: "center",
      marginTop: 43.4,
    },
    logoText: {
      textAlign: "center",
      width: "200%",
      marginTop: "60px",
      marginBottom: "60px",
      fontSize: 18,
    },
    signInButton: {
      width: 311,
      height: 38,
      flexGrow: 0,
      padding: "10px 50px 10px 70px !important",
      marginTop: 24,
      borderRadius: "5px !important",
      boxShadow:
        " 0 2px 3px 0 rgba(0, 0, 0, 0.17), 0 0 3px 0 rgba(0, 0, 0, 0.08) !important",
      backgroundColor: "#FFF",
      "& div": {
        padding: "4px !important",
      },
      "& span": {
        padding: "0px !important",
        fontWeight: "800 !important",
        fontSize: "15px !important",
      },
    },
    form: {
      marginTop: 40,
    },
    mobileView: {
      width: 392,
      height: 851,
      flexGrow: 0,
      padding: "64px 40px 305px",
    },
    mobileViewTextBox: {
      marginTop: 8,
      color: "#b8b8b8",
      height: 48,
    },
    registerSection: {
      display: "flex",
      flexDirection: "column",
      fontSize: 17,
      fontWeight: 600,
      marginTop: 40,
      textAlign: "center",
      "& a": {
        color: "#48b7a7 !important",
        fontWeight: "bold",
        marginLeft: 6,
      },
    },
    logoTextBox: {
      display: "flex",
      justifyContent: "center",
    },
    optionText: {
      fontSize: 15,
      margin: "15px 0px 5px",
      fontWeight: "bold",
    },
    forgotPassword: {
      fontSize: 15,
      margin: "2px 0px 6px",
      fontWeight: "bold",
    },
    // necessary for content to be below app bar
  })
);

export const Login: React.FC<LoginProps> = ({}) => {
  const clientId =
    "381059260317-rl1qvckjoef2o5niim5h2um7nspakgv5.apps.googleusercontent.com";
  //ReactGA.initialize('G-BDNR3RLJHR');
  ReactGA.pageview(window.location.pathname);
  const eventTrackLogin = (category, action, label) => {
    //console.log("GA event:", category, ":", action, ":", label);
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  };

  const classes = useStyles();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [enableButton, setEnableButton] = useState(false);
  const [option, setOption] = useState(1);
  const [checkedState, setCheckedState] = useState(false);
  const matches = useMediaQuery('(max-width:393px)');

  useEffect(() => {
    setEnableButton(email.length > 0 && password.length > 6);
  }, [email.length, password.length]);

  function validateForm() {
    return email.length > 0 && password.length > 0;
  }

  function setToken(userToken) {
    //console.log('token set');
    localStorage.setItem("token", JSON.stringify(userToken));
    sessionStorage.setItem("token", JSON.stringify(userToken));
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    setPassword("");
    const regExpEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (regExpEmail.test(email)) {
      try {
        AuthService.login(email, password, 1)
          .then(() => {
            localStorage.setItem("email", email);
            eventTrackLogin("Sign In", "Normal Sign In", "Button");
            history.push("/");
          })
          .catch(() => {});
      } catch (e) {}
    } else {
      toast.error("Please type correct email");
    }
  };

  // const handleSubmitMobile = async (e) => {
  //   e.preventDefault();
  //   try{
  //     AuthService.mobileEmail(email).then(
  //       () => {
  //         eventTrackLogin('Mobile Email', 'Send Mobile Email', 'Button');
  //         history.push("/");
  //       },
  //     )
  //   } catch(e: any){
  //     alert(e.message);
  //   }
  // }

  const responseGoogle = (response) => {
    const userInfo = response.profileObj;
    if (userInfo) {
      //console.log('info works');
      try {
        AuthService.loginGoogle(
          userInfo.email,
          userInfo.googleId,
          userInfo.givenName,
          userInfo.familyName,
          1
        ).then(() => {
          eventTrackLogin("Sign In", "Google Sign In", "Button");
          history.push("/");
        });
      } catch (e) {
        // alert(e.message);
      }
    }
  };

  const failResponseGoogle = (response) => {
    alert(response);
  };

  function changeOption() {
    if (option === 0 && checkedState === false) {
      setOption(1);
      setCheckedState(true);
      //console.log(option);
    } else if (option === 1 && checkedState === true) {
      setOption(1);
      setCheckedState(false);
      //console.log('default');
      //console.log(option);
    } else {
      setOption(1);
      setCheckedState(false);
    }
  }
  const [index, setIndex] = useState(0);
  //imports the SignUp componenet
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  return (
    <div>
      {!matches?
      <div>
        <div>
          <Container className="container">
            <Row className="row">
              {/* this is the carousel*/}
              <div className="leftPanel">
                <div className={classes.logoBox}>
                  <a href="https://www.sotira.co/">
                    <img alt="logo" className={classes.logo} src={larlogo} />
                  </a>
                </div>
                <div className="carousel">
                  <div className={classes.logoTextBox}></div>

                  <div className="Login">
                    <Carousel
                      pause="hover"
                      className="carousel-content"
                      bsPrefix="carousel"
                      indicators={false}
                      fade={true}
                      nextLabel={null}
                      prevLabel={null}
                      slide={true}
                      activeIndex={index}
                      onSelect={handleSelect}
                    >
                      <Carousel.Item
                        className="carousel-item"
                        style={{ height: "525px" }}
                      >
                        <img
                          style={{ height: "350px", width: "450px" }}
                          src={img1}
                          alt="First slide"
                        />
                        <Carousel.Caption>
                          <div className="carousel-text isLong">
                            <strong>
                              <h5 style={{ color: "black" }}>
                                One stop shop for all ecommerce transactions
                              </h5>
                            </strong>
                            <p style={{ color: "black" }}>
                              Say no to Excel spreadsheets
                            </p>
                            <p style={{ color: "black" }}>
                              Upload your excel sheets instantly to Sotira
                            </p>
                            <p style={{ color: "black" }}>
                              Synch your sales to automatically update in real
                              time on Sotira
                            </p>
                          </div>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item style={{ height: "540px" }}>
                        <img
                          style={{ height: "350px", width: "450px" }}
                          src={img2}
                          alt="Second slide"
                        />
                        <Carousel.Caption>
                          <div className="mt-4">
                            <h5 style={{ color: "black" }}>
                              Customized and personalized to the platforms you
                              sell on
                            </h5>
                            <p style={{ color: "black" }}>
                              Sotira is the most customizable ecommerce platform
                              to manage your online business as a seller or
                              reseller
                            </p>
                            <p style={{ color: "black" }}>
                              Financial templates and pricing tools are custom
                              filled with fees for ecommerce platforms
                            </p>
                          </div>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item style={{ height: "540px" }}>
                        <img
                          style={{ height: "350px", width: "450px" }}
                          src={img3}
                          alt="Third slide"
                        />
                        <Carousel.Caption>
                          <div className="mt-4">
                            <h5 style={{ color: "black" }}>
                              Be more profitable
                            </h5>
                            <p style={{ color: "black" }}>
                              Pick the right marketplace for the products you
                              sell - automatically compare projected profit
                              across multiple marketplaces
                            </p>{" "}
                            <p style={{ color: "black" }}>
                              See which products or product collections are top
                              selling
                            </p>{" "}
                            <p style={{ color: "black" }}>
                              Analyze profitability for your business(es)
                            </p>
                          </div>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item style={{ height: "540px" }}>
                        <img
                          style={{ height: "350px", width: "450px" }}
                          src={img4}
                          alt="Fourth slide"
                        />
                        <Carousel.Caption>
                          <div className="mt-4">
                            <h5 style={{ color: "black" }}>
                              Take your business to the next level
                            </h5>
                            <p style={{ color: "black" }}>
                              Efficiently price products and calculate listing
                              prices
                            </p>
                            <p style={{ color: "black" }}>
                              Set and monitor sales goals to hold yourself
                              accountable
                            </p>
                            <p style={{ color: "black" }}>
                              Cap your expenses and see ways to cut down costs
                              or source products cheaper
                            </p>
                          </div>
                        </Carousel.Caption>
                      </Carousel.Item>
                    </Carousel>
                  </div>
                </div>
              </div>

              {/* this is the side Login */}

              <div
                className="rightPanel"
                style={{
                  backgroundColor: "white",
                  paddingBottom: "5%",
                }}
              >
                <div className="Login">
                  <Form onSubmit={handleSubmit}>
                    <div className="navStyle">
                      {/*Navigation Bar - create a component maybe */}
                      <NavBar></NavBar>
                    </div>
                    <h2 className="titleLog"> Log In </h2>
                    <Form.Group>
                      <GoogleLogin
                        clientId={clientId}
                        onSuccess={responseGoogle}
                        onFailure={responseGoogle}
                        cookiePolicy={"single_host_origin"}
                        className="google-login"
                      />
                    </Form.Group>
                    <Form.Group controlId="email">
                      <Form.Label className="title"> Email</Form.Label>
                      <Form.Control
                        autoFocus
                        type="email"
                        placeholder="Enter email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group controlId="password">
                      <Form.Label className="title">Password</Form.Label>
                      <Form.Control
                        type="password"
                        value={password}
                        placeholder="Enter password"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </Form.Group>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: 20,
                      }}
                    >
                      <Button
                        block
                        className="login-button"
                        size="lg"
                        type="submit"
                        disabled={!validateForm()}
                      >
                        Login
                      </Button>
                    </div>

                    <div className={classes.optionText}>
                      Don't have an account?
                      <a style={{ color: "#89D0C6" }} href="/auth/register">
                        {" "}
                        Register here{" "}
                      </a>
                    </div>
                    <div className={classes.forgotPassword}>
                      Forgot password?
                      <a
                        style={{ color: "#89D0C6" }}
                        href="/auth/forgotPassword"
                      >
                        {" "}
                        Click Here
                      </a>
                    </div>
                  </Form>
                </div>
              </div>
            </Row>
          </Container>
        </div>
      </div>:
      <MobileView className={classes.mobileView}>
        <div className={classes.mobileLogoBox}>
          <img alt="logo" className={classes.logo} src={larlogo} />
        </div>
        <div>
          <p className={classes.logoIn}>Log In</p>
        </div>
        <GoogleLogin
          clientId={clientId}
          onSuccess={responseGoogle}
          onFailure={responseGoogle}
          cookiePolicy={"single_host_origin"}
          className={classes.signInButton}
        />

        <Form onSubmit={handleSubmit} className={classes.form}>
          <Form.Group controlId="email">
            <Form.Label className="input-title"> Email </Form.Label>
            <Form.Control
              autoFocus
              type="email"
              placeholder="Enter email address"
              value={email}
              className={classes.mobileViewTextBox}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="password">
            <Form.Label className="input-title"> Password </Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter password"
              value={password}
              className={classes.mobileViewTextBox}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>

          <Button
            className="mobile-view-button"
            size="lg"
            type="submit"
            disabled={!enableButton}
          >
            Log In
          </Button>
        </Form>
        <div className={classes.registerSection}>
          <span>
            Don't have an account?<a href="/auth/register">Register here</a>
          </span>
          <span className="mt-2">
            Forgot password?<a href="/auth/forgotPassword">Click here</a>
          </span>
        </div>
      </MobileView>}
    </div>
  );
};
